/// <reference types="./proposal_file.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function proposal_file() {
  return $svg.square(
    16,
    "<path d=\"M14 5.33337V13.9954C14.0006 14.0829 13.984 14.1697 13.951 14.2509C13.9181 14.332 13.8695 14.4058 13.808 14.4682C13.7466 14.5305 13.6734 14.5801 13.5928 14.6142C13.5121 14.6482 13.4255 14.6661 13.338 14.6667H2.662C2.48654 14.6667 2.31826 14.5971 2.19413 14.473C2.07 14.349 2.00018 14.1808 2 14.0054V1.99471C2 1.63671 2.29933 1.33337 2.668 1.33337H9.998L14 5.33337ZM12.6667 6.00004H9.33333V2.66671H3.33333V13.3334H12.6667V6.00004Z\" fill=\"currentColor\"/>",
  );
}
